import { computed, makeAutoObservable } from 'mobx';
import { ModelsState } from 'src/AppState/Models/ModelsState';
import { RouterBackoffice } from 'src/AppState/RouterBackoffice';

type CustomerRouteType =
    | 'customer-summary'
    | 'banking'
    | 'personal-details'
    | 'customer-settings'
    | 'responsible-gambling'
    | 'transaction-history'
    | 'free-spin-transaction-history'
    | 'marketing';

interface MenuItemsType {
    id: CustomerRouteType;
    label: string;
    onClick: () => void;
}

export class CustomerMenuItemsState {
    public constructor(
        private readonly routerBackoffice: RouterBackoffice,
        private readonly models: ModelsState,
        private readonly accountId: () => number
    ) {
        makeAutoObservable(this);
    }

    public isKycWatchlist = (): boolean => {
        const kycWatchlist = this.models.getUserModel(this.accountId()).basicData.data?.kycWatchlist;
        return kycWatchlist !== null && kycWatchlist !== undefined;
    };

    @computed public get getCustomerParams(): string {
        return this.routerBackoffice.getParametersString('customers', 'tab.tab') ?? 'customer-summary';
    }

    public isTabActive = (label: string): boolean => {
        return this.getCustomerParams === label;
    };

    public menuItems: Array<MenuItemsType> = [
        {
            id: 'customer-summary',
            label: 'Summary',
            onClick: (): void => this.routerBackoffice.redirectToCustomerSummary(),
        },
        {
            id: 'banking',
            label: 'Banking',
            onClick: (): void => this.routerBackoffice.redirectToCustomerBanking(),
        },
        {
            id: 'personal-details',
            label: 'Personal details',
            onClick: (): void => this.routerBackoffice.redirectToCustomerPersonalDetails(),
        },
        {
            id: 'customer-settings',
            label: 'Customer settings',
            onClick: (): void => this.routerBackoffice.redirectToCustomerCustomerSettings(),
        },
        {
            id: 'responsible-gambling',
            label: 'Responsible gambling',
            onClick: (): void => this.routerBackoffice.redirectToCustomerResponsibleGambling(),
        },
        {
            id: 'transaction-history',
            label: 'Transaction history',
            onClick: (): void => this.routerBackoffice.redirectToCustomerTransactionHistory(),
        },
        {
            id: 'free-spin-transaction-history',
            label: 'Free Spin Transaction history',
            onClick: (): void => this.routerBackoffice.redirectToCustomerFreeSpinTransactionHistory(),
        },
        {
            id: 'marketing',
            label: 'Marketing',
            onClick: (): void => this.routerBackoffice.redirectToCustomerMarketing(),
        },
    ];
}
